import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Button from "components/Elements/Button/Button.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import Image from "components/Elements/Image/Image.tsx";
import Authentication from "components/Reusable/Authentication/index.tsx";
import { useUser } from "contexts/userContext/userContext.js";
import { useParams } from "react-router-dom";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { InviteSubUserCheckboxAgreement } from "components/Pages/SubUsers/InviteSubUserCheckboxAgreement.tsx";
import "./InvitationLinkCard.scss";

const InvitationEmailCard = ({ setJoin, setProfileLogo }) => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const params = useParams();
  const { getUserData, isLoggedIn, logout, setUserDataProp } = useUser();
  const [subUsersData, setSubUsersData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const { setModal } = useModal();
  const userData = getUserData() || {};
  const [isJoinAllowed, setIsJoinAllowed] = useState(
    userData.UserName ? !!userData.UserName : undefined
  );

  useEffect(() => {
    fetchSubUserData();
  }, [isLoggedIn()]);

  const fetchSubUserData = async () => {
    const response = await apiRequest(
      "SubUsers",
      `ReactGetSubUserDataByEmail?token=${params.token}`,
      null,
      "POST"
    );

    if (response.status === "success") {
      if (response.data.BucketName) {
        // Redirect to custom domain if BucketName exist
        const newOrigin = response.data.BucketName;
        if (window.location.origin !== newOrigin) {
          window.location.href = `${newOrigin}${window.location.pathname}`;
          return;
        }
      }
      // There is error
      setErrorMessage("");
      if (response.data.ErrorMessage) {
        setErrorMessage(response.data.ErrorMessage);

        if (response.data.ErrorMessage === "user-is-subscriber") {
          logout();
        }
      }

      setUserDataProp({
        key: "EnforceStrongPass",
        value: response.data?.EnforceStrongPass,
      });
      // if profileLogo exist
      if (response.data.DownloadLogoImage) {
        setProfileLogo(response.data.DownloadLogoImage);
      } else {
        setProfileLogo("default");
      }
      setSubUsersData(response.data);
      if (isLoggedIn()) {
        completeAddSubUser();
      }
      setLoading(false);
    } else {
      setProfileLogo("default");
      setErrorMessage(response.data);
    }
  };

  const completeAddSubUser = async () => {
    const parameters = {
      token: params.token,
    };

    const response = await apiRequest(
      "SubUsers",
      "ReactCompleteAddSubUser",
      parameters,
      "POST"
    );

    if (response.status === "success") {
      setJoin(response.data);
    }
  };

  const logOutAndOpenLoginModal = () => {
    logout();
    setModal({
      modal: Authentication,
      modalSize: "full-modal",
      props: {
        type: subUsersData.UserExists ? "sign-in" : "join-org",
        onSubUserSubmitSuccess: completeAddSubUser,
        subUserDomain: subUsersData.Domain,
        // enforceStrongPass: getUserData().EnforceStrongPass,
      },
    });
  };

  const isErrorMessageVisible = !!errorMessage;
  const isTokenExpiredError =
    isErrorMessageVisible && errorMessage === "expired-token";
  const isChangeAccountVisible =
    isErrorMessageVisible &&
    !!userData.UserName &&
    subUsersData.InvitedUserEmail !== userData.UserName;

  return (
    <div className="invitation-card-wrapper">
      {loading ? (
        <div className="loading-blog-container">
          <LoadingImageElement />
        </div>
      ) : (
        <>
          {subUsersData.ProfileImage && (
            <div className="top-user-logo">
              <Image src={subUsersData.ProfileImage} alt="sub-user-image" />
            </div>
          )}

          <div className="invitation-sub-title">
            {subUsersData.OrganizationName || subUsersData.UserFullName}{" "}
            {getTextByKey("invitation-sub-title")}
          </div>
          <div className="invitation-sub-user-domain">
            {subUsersData.Domain}
          </div>
          <div className="invitation-sub-user-amount-of-users">
            <Icon
              name="sub-users-image"
              iconClass="sub-user-image"
              ext="png"
              xxl
            />{" "}
            {subUsersData.NumberOfUsers}{" "}
            {getTextByKey("invitation-sub-user-amount-of-user")}
          </div>

          {!isTokenExpiredError ? (
            <>
              {isErrorMessageVisible ? (
                <>
                  <div className="invitation-sub-user-error">
                    {getTextByKey(errorMessage).replace(
                      "#email#",
                      subUsersData.InvitedUserEmail || ""
                    )}
                  </div>
                  {!isTokenExpiredError &&
                  !isChangeAccountVisible &&
                  !loading ? (
                    <InviteSubUserCheckboxAgreement
                      onAgreementChange={(state) => setIsJoinAllowed(state)}
                      agreementText={getHtmlByKey(
                        "invite-subuser-checkbox-email"
                      )}
                      agreementChecked={isJoinAllowed}
                    />
                  ) : null}
                  <Button
                    medium
                    onClick={() =>
                      isJoinAllowed || isChangeAccountVisible
                        ? logOutAndOpenLoginModal()
                        : setIsJoinAllowed(false)
                    }
                  >
                    {getTextByKey(
                      isChangeAccountVisible ? "change-account" : "join"
                    )}
                  </Button>
                </>
              ) : (
                <>
                  <Button onClick={() => completeAddSubUser()} medium>
                    {getTextByKey("join")}
                  </Button>
                </>
              )}
            </>
          ) : null}
        </>
      )}
    </div>
  );
};

export default InvitationEmailCard;
